import { showError, showResponseError } from 'utils/messages';
import { setLocation } from 'utils/wrappers';

import DropdownSelections from 'app/collections/dropdown_selections';

import Base from 'app/views/base';
import tmpl from './template';

export const MAX_REPORT_TIME_SPAN_DAYS = 31;

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click #request-report': 'requestReport',
  },

  initialize({
    ReportClass,
    apiModeSelection,
    dateRange,
    dropdownSelections = new DropdownSelections([]),
    maxDays = MAX_REPORT_TIME_SPAN_DAYS,
    filterId,
  }) {
    this.ReportClass = ReportClass;
    this.apiModeSelection = apiModeSelection;
    this.dropdownSelections = dropdownSelections;
    this.dateRange = dateRange;
    this.maxDays = maxDays;
    this.filterId = filterId;
  },

  requestReport() {
    if (this.maxDays && this.dateRange.daysBetweenDates() > this.maxDays) {
      showError(`Sorry, CSV reports are limited to ${this.maxDays} days at a time.`);
      return;
    }

    new this.ReportClass().save(this.paramsForReport(), {
      success(model) {
        const reportId = model.get('id');
        const mode = model.get('mode');
        setLocation(`/account/reports/${model.reportType}#/${reportId}?mode=${mode}`);
      },
      error(model, resp) {
        showResponseError(resp);
      },
    });
  },

  paramsForReport() {
    const params = {
      send_email: true,
      ...this.apiModeSelection.getParams(),
      ...this.dropdownSelections.getParams(),
      start_date: this.dateRange.getStartDatetimeForParam().format('YYYY-MM-DD'),
      end_date: this.dateRange.getDayAfterEndDatetimeForParam().format('YYYY-MM-DD'),
    };

    if (this.filterId) {
      params.filter_id = this.filterId;
    }

    return params;
  },

  context() {
    return {
      maxDays: this.maxDays,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/request_report/index.js